<template>
  <v-app class="fundo">
    <v-app-bar app>
      <v-app-bar-nav-icon class="black white--text" @click="drawer = !drawer">
      </v-app-bar-nav-icon>

      <!-- VAI PARA HOME -->
      <!-- <a class="ml-5" :to="{ name: 'home' }"> -->
      <router-link :to="{ name: 'Home' }" class="ml-3">
        <v-img :src="require('@/assets/logo-seara.png')" width="90"> </v-img>
      </router-link>
      <!-- </a> -->

      <v-spacer></v-spacer>

      <!-- TITULO PAGINA -->
      <v-toolbar-title>
        {{ $t("app.tituloPagina") }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- TRADUÇÃO BANDEIRAS -->
      <a class="mx-1" @click="traduzir('pt')">
        <v-img :src="require('@/assets/brasil.png')" max-width="45" class="rounded-pill">
        </v-img>
      </a>
      <a class="mx-1" @click="traduzir('en')">
        <v-img :src="require('@/assets/inglaterra.png')" max-width="45" class="rounded-pill">
        </v-img>
      </a>
      <a class="ml-1 mr-5" @click="traduzir('es')">
        <v-img :src="require('@/assets/espanha.png')" max-width="45" class="rounded-pill">
        </v-img>
      </a>

      <!-- BOTÃO SAIR -->
      <v-btn dark @click="sair">
        <!-- <v-btn dark to ="/logout"> -->
        {{ $t("app.Sair") }}
        <v-icon dark right> mdi-power-standby </v-icon>
      </v-btn>
    </v-app-bar>

    <!-- MENU LATERAL ESQUERDO -->

    <!-- <v-navigation-drawer app absolute temporary bottom v-model="drawer"> -->
    <v-navigation-drawer app v-model="drawer">
      <!-- <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h5"> Portal Web </v-list-item-title>
          <v-list-item-subtitle> Mercado Externo </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->

      <v-divider></v-divider>

      <v-list nav>
        <v-list-item v-for="(item, index) in itemsMenu" :key="index" :to="{ name: item.name }" :target="item.target">
          <v-list-item-content>
            <v-list-item-title :class="item.class">{{ item.title }}</v-list-item-title>
            <!-- <router-link :to="{ path: item.rota }">{{ item.rota }}</router-link> -->
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon :size="item.iconSize">{{ item.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <!-- BOTÃO SAIR -->
      <!-- <template v-slot:append>
        <div class="pa-2">
          <v-btn dark block @click="sair">
            {{ $t("app.Sair") }}
            <v-icon dark right> mdi-power-standby </v-icon>
          </v-btn>
        </div>
      </template> -->
    </v-navigation-drawer>

    <!-- CONTEÚDO -->
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
// import i18n from "./plugins/i18n";
// @ is an alias to /src

export default {
  name: "App",
  data: () => ({
    drawer: null,
  }),
  methods: {
    traduzir(idioma) {
      if (idioma && this.$i18n.locale != idioma) {
        // Mudar local I18N e Vuetify
        this.$i18n.locale = idioma;
        this.$vuetify.lang.current = idioma;
        localStorage.setItem("idioma", idioma);

        // Tradução página
        document.title = this.$i18n.t("app.tituloPagina");
        document.documentElement.lang = idioma;

        //Enviar tradução para gravar no back end - perfil do usuário
        this.enviarIdiomaBackend(idioma);
      }
    },
    enviarIdiomaBackend(idioma) {
      let urlParametro;
      let urlLocal = "/listar/listar_idioma";

      // DEFINIR AMBIENTE DE EXECUÇÃO
      if (this.$ambiente == "DEV") urlLocal = this.$urlDEV + urlLocal;

      let objIdioma = { pt: 1, en: 2, es: 3 };
      let australopitecus = sessionStorage.getItem("australopitecus");
      //se não encontrar login sai da rotina(telas de login/cadastro usuario/alterar senha)
      // console.log(australopitecus);
      if (!australopitecus) {
        console.log("australopitecus não encontrado", australopitecus);
        return;
      }
      australopitecus = atob(australopitecus);

      //  australopitecus = "jorge.manuel@seara.com.br";
      urlParametro =
        urlLocal +
        "?id_usuario=" +
        australopitecus +
        "&cd_idioma=" +
        objIdioma[idioma];

      fetch(urlParametro)
        .then((response) => {
          // console.log("RESPONSE:", urlLocal, response);
          return response.json();
        })
        .then((json) => {
          // console.log("Sucesso JSON:", json);
          return json;
        })
        .catch((erro) => {
          console.log("ERRO:", urlParametro, erro);
        });
    },
    sair() {
      // fazer logoff
      sessionStorage.removeItem("australopitecus");
      window.location.replace("/");
    },
  },
  computed: {
    itemsMenu() {
      return [
        {
          title: this.$i18n.t("app.Inicio"),
          icon: "mdi-home ",
          iconSize: "24",
          name: "Home",
          rota: "/app",
          class: "",
        },
        {
          // title: "Consultar Contrato",
          title: this.$i18n.t("app.ConsultarContrato"),
          icon: "mdi-magnify",
          iconSize: "24",
          name: "ConsultarContrato",
          rota: "/app/consultar_contrato",
          target: "_self",
          class: "",
        },
        {
          title: this.$i18n.t("app.GerarContrato"),
          icon: "mdi-receipt-text-plus ",
          iconSize: "24",
          name: "GerarContrato",
          rota: "/app/gerar_contrato",
          target: "_self",
          class: "",
          // class: "font-weight-black",
        },
        //####
        // {
        //   title: this.$i18n.t("app.GerarContrato"),
        //   icon: "mdi-plus",
        //   iconSize: "24",
        //   name: "GerarContrato",
        //   rota: "/gerar_contrato",
        //   target: "_blank",
        //   class: "",
        // },
        {
          title: this.$i18n.t("app.ConsultarPricing"),
          icon: "mdi-cash",
          iconSize: "24",
          name: "Pricing",
          rota: "/app/pricing",
          target: "_self",
          class: "",
        },
        {
          title: this.$i18n.t("app.ConsultarCredito"),
          icon: "mdi-account-cash",
          iconSize: "24",
          name: "Credito",
          rota: "/app/credito",
          target: "_self",
          class: "",
        },
        {
          title: 'Sales Sent Report',
          icon: "mdi-file-table",
          iconSize: "24",
          name: "SalesSentReport",
          rota: "/app/sales_sent_report",
          target: "_self",
          class: "",
        },

        // {
        //   title: "Idioma",
        //   icon: "mdi-translate",
        //   name: "Idioma",
        //   rota: '/app/Idioma',
        //   target: "_self",
        // },
      ];
    },
  },
  mounted() {
    //verificar idioma do usuário

    // eslint-disable-next-line
    // debugger;
    this.traduzir(localStorage.getItem("idioma"));
    /*
    let idioma = localStorage.getItem("idioma");
    if (idioma && this.$i18n.locale != idioma) {
      this.$i18n.locale = idioma;
      this.$vuetify.lang.current = idioma;
      document.documentElement.lang = idioma;
      document.title = this.$i18n.t("app.tituloPagina");
    }
    */
  },
};
</script>

<style scoped>
/* IMAGEM DE FUNDO */
.fundo {
  background-image: url("../assets/fundo_sem_logo_claro.jpg");
  background-size: cover;
}
</style>